export interface IExamAttempt {
  idExamAttempt: string;
  score?: number | null;
  passed?: boolean | null;
  startedAt?: string | null;
  finishedAt?: string | null;
  status: string;
  canStart: boolean;
  correctCount?: number | null;
  totalCount?: number | null;
}

export class ExamAttempt {
  idExamAttempt: string;
  score: number | null;
  passed: boolean | null;
  startedAt: Date | null;
  finishedAt: Date | null;
  status: string;
  canStart: boolean;
  correctCount: number | null;
  totalCount: number | null;

  constructor(data: IExamAttempt) {
    this.idExamAttempt = data.idExamAttempt;
    this.score = data.score ?? null;
    this.passed = data.passed ?? null;
    this.startedAt = data.startedAt ? new Date(data.startedAt) : null;
    this.finishedAt = data.finishedAt ? new Date(data.finishedAt) : null;
    this.status = data.status;
    this.canStart = data.canStart;
    this.correctCount = data.correctCount ?? null;
    this.totalCount = data.totalCount ?? null;
  }
}
